<template>
  <div>
    <div  class="loading" @touchmove.prevent="">
      <i></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["freeObj"],
  data() {
    return {
    };
  },
  components: {},
  watch: {
    ["freeObj"]() {
      if (this.freeObj) {
        this.pay();
      }
    },
  },
  mounted() {
    if (this.freeObj) {
      this.pay();
    }
  },
  methods: {
    pay() {
      var freeObj = this.freeObj;
      var obj = {
        ordertype: freeObj.ordertype,
        details: [
          {
            productid: freeObj.productid,
            quantity: freeObj.buyNum ? freeObj.buyNum : 1,
          },
        ],
        payment: { paymentmode: 1007, subpaymode: 1003 },
      };

      if (freeObj.ordertype == 1004) {
        obj.details[0].ticket = { tickettype: freeObj.tickettype };
      }
      this.$post("iart-api-oaf/api/oaf/customer/order", obj).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.$emit("freePayCallback", { type: "success",orderid:res.data.orderid });
            } else {
              this.$emit("freePayCallback", { type: "error" });
              this.util.toast({ msg: res.data.rtnmsg });
            }
          } else {
            this.$emit("freePayCallback", { type: "error" });
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  i {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-bottom-color: transparent;
    vertical-align: middle;
    animation: mescrollRotate 0.6s linear infinite;
  }
}
@keyframes mescrollRotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>